export default __webpack_public_path__ + "static/media/kakao_share.0696615e.svg";